export default "__VITE_ASSET__CpqcamF7__"